import { render } from "./MaterialSheetForecast.vue?vue&type=template&id=ad50aa48"
import script from "./MaterialSheetForecast.vue?vue&type=script&lang=js"
export * from "./MaterialSheetForecast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__